import React from 'react'
import styles from './EmptyTexte.module.css'

const EmptyTexte = ({ children }) => (
  <div className={styles.content}>{children}</div>
)

export default EmptyTexte
